import { render } from "./Edit.vue?vue&type=template&id=97b1b32e"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Invoices/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "97b1b32e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('97b1b32e', __exports__)) {
    api.reload('97b1b32e', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=97b1b32e", () => {
    api.rerender('97b1b32e', render)
  })

}


export default __exports__